import type { Column } from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { Button } from '@/shared/components/ui';
import { cn } from '@/shared/lib/utils';

interface SortableHeaderProps<TData, TValue> {
  column: Column<TData, TValue>;
  title: string;
  className?: string;
}

export function SortableHeader<TData, TValue>({
  column,
  title,
  className,
}: SortableHeaderProps<TData, TValue>) {
  const sortDirection = column.getIsSorted();

  const handleSortingClick = () => {
    if (sortDirection === 'desc') {
      column.clearSorting(); // Clear sorting if currently descending
    } else {
      column.toggleSorting(sortDirection === 'asc'); // Toggle between none → asc → desc
    }
  };

  return (
    <Button
      variant="ghost"
      onClick={handleSortingClick}
      className={cn('hover:bg-transparent p-0 font-medium', className)}
    >
      {title}
      {sortDirection === 'asc' ? (
        <ArrowUp className="size-4" />
      ) : sortDirection === 'desc' ? (
        <ArrowDown className="size-4" />
      ) : (
        <ArrowUpDown className="size-4 opacity-0 group-hover:opacity-100" />
      )}
    </Button>
  );
}
